import { isMobile } from 'shared/vidio_helpers';
import GoogleTagAdapter from 'components/shared/GoogleTagAdapter/GoogleTagAdapter';
import GooglePublisherTag from 'components/shared/GooglePublisherTag/GooglePublisherTag';
import DesktopBannerAd from '../../desktop/BannerAd/BannerAd';
import MobileBannerAd from '../../mobile/BannerAd/BannerAd';
import Tercept from '../Tercept/Tercept';

const Cookies = require('js-cookie');

export default class BannerAd {
  static setup() {
    if(!BannerAd.shouldSetupBannerAd()) {
      return;
    }
    
    if(isMobile()) {
      MobileBannerAd.setup();
    } else {
      DesktopBannerAd.setup();
    }

    Tercept.setTargeting();
    GooglePublisherTag.displayAllBanners();
  }

  static shouldSetupBannerAd() {
    if(window.kmklabs === undefined || window.kmklabs.gpt === undefined) {
      return false;
    }

    var premiumCookie = Cookies.get("_vidio");
    if(window.isUserSignedIn && premiumCookie === "true") {
      return false;
    }

    return true;
  }

  static setBannerAd(container_id, ad_slot_name, ad_unit, ad_size, setBannerFunction, refreshFunction) {
    var bannerContainer = document.getElementById(container_id);
    
    if(bannerContainer) {
      var bannerDiv = document.createElement("div");
      bannerDiv.id = ad_slot_name;
      bannerContainer.appendChild(bannerDiv);

      setBannerFunction(ad_unit, ad_size);

      if(refreshFunction){
        GoogleTagAdapter.push(refreshFunction);
      }
    }
  }
}